import {Theme} from "@mui/material";
import {SxProps} from "@mui/system";
import React, {ReactNode} from "react";
import {Colors, Container, ITextProps, LabelColors, LabeledText, Text} from "../../ui";

interface IKeyValueField {
  field: string;
  value: ReactNode;
  size?: ITextProps["size"];
  textTransform?: string;
  labelColor?: LabelColors;
  multi?: boolean;
  nowrap?: boolean;
  sx?: SxProps<Theme>;
}

interface IValueField {
  labelColor: LabelColors;
  value: ReactNode;
  size?: ITextProps["size"];
  multi?: boolean;
  nowrap?: boolean;
  lowerCase?: boolean;
}

const ValueField = ({labelColor, value, size = 14, multi, nowrap = true, lowerCase = false}: IValueField) => {
  return labelColor && labelColor !== "none" ? (
    <LabeledText size={size} fontWeight={"medium"} backgroundColor={labelColor} sx={{display: "inline"}}>
      {value}
    </LabeledText>
  ) : (
    <Text
      size={size}
      fontWeight={"medium"}
      sx={{display: "inline", ...(nowrap && {whiteSpace: "nowrap", ...(lowerCase && {textTransform: "lowercase"})})}}
    >
      {value}
      {multi && ","}
    </Text>
  );
};

export const KeyValueField = ({
  field,
  value,
  size = 14,
  textTransform = "capitalize",
  labelColor = "none",
  multi = false,
  nowrap = true,
  sx,
}: IKeyValueField) => {
  return (
    <Container row sx={{justifyContent: "start", alignItems: "start", ...sx}}>
      <Text size={size} sx={{display: "inline", textTransform, color: Colors.grey._700}}>
        {field}
        {": "}
        <ValueField
          value={value}
          labelColor={labelColor}
          multi={multi}
          nowrap={nowrap}
          lowerCase={field === "Email"}
          size={size}
        />{" "}
      </Text>
    </Container>
  );
};
